import { TunaDialog, DialogContent, DialogActions } from '../primitives/dialog.js'
import { Button } from '../primitives/button.js'
import { LinearProgress } from '../primitives/linear-progress.js'
import type { FC } from 'react'
import React from 'react'
import { DialogTitle } from './dialog-title.js'
import moduleStyles from './confirm-dialog.module.css'

export interface ConfirmDialogProps {
  className?: string
  open: boolean
  title?: string
  /** Busy - disable all inputs / buttons and show a progress bar */
  busy?: boolean
  /** OK button is enabled */
  enabled?: boolean
  okText?: string
  cancelText?: string
  text: string
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  fullWidth?: boolean
  children?: React.ReactNode
  /** @deprecated use onCancel instead */
  onClose?: (ev: React.SyntheticEvent) => void
  onCancel(ev: React.SyntheticEvent): void
  onConfirm(ev: React.SyntheticEvent): void
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  children,
  text,
  busy = false,
  open,
  okText = 'OK',
  cancelText = 'Cancel',
  enabled = true,
  onConfirm,
  onCancel,
  title = 'Confirm',
  maxWidth,
}) => {
  if (!open) {
    return null
  }
  return (
    <TunaDialog open={open} onClose={() => onCancel({} as React.SyntheticEvent)} maxWidth={maxWidth}>
      <div onClick={ev => ev.stopPropagation()}>
        <DialogTitle onClose={onCancel} id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <p id="alert-dialog-description">{text}</p>
          {children}
          {busy ? <LinearProgress className={moduleStyles.progressBar} /> : null}
        </DialogContent>
        <DialogActions>
          <Button disabled={busy} onClick={onCancel}>
            {cancelText}
          </Button>
          <Button disabled={busy || !enabled} onClick={onConfirm} autoFocus={true}>
            {okText}
          </Button>
        </DialogActions>
      </div>
    </TunaDialog>
  )
}

export default ConfirmDialog
